import React from 'react'
import VideoItem from './VideoItem'

function VideoList({ videos, onVideoSelect }) {

    const rendereList = videos.map(video => {
        return <VideoItem video={video} onVideoSelect={onVideoSelect} key={video.id.videoId} />
    })

    return (
        <div className='ui relaxed divided list'>
            {rendereList}
        </div>
    )
}

export default VideoList
